import React, { useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';

const Filter:React.FC<IProps> = (props) => {
  const [checked, setChecked]=useState(false);

  const handleCheckboxChange = (evt:React.ChangeEvent<HTMLInputElement>) => {
    setChecked(evt.currentTarget.checked)
    props.onChange(props.value?props.value:props.label, props.type, evt.currentTarget.checked);
  };

  useEffect(() => {
    if(props.checked!=undefined)setChecked(props.checked);
  }, [props.checked]);
  
  return (
    <S.Root style={props.rootStyle}>
      {props.labelLeft && <S.Label style={props.labelStyle}>{props.label}</S.Label>}
      <S.CheckboxContainer className=''>
        <S.HiddenCheckbox checked={checked} onChange={(evt)=>handleCheckboxChange(evt)}/>
        <S.StyledCheckbox checked={checked}>
          <S.Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </S.Icon>
        </S.StyledCheckbox>
      </S.CheckboxContainer>
      {!props.labelLeft && <S.Label style={props.labelStyle}>{props.label}</S.Label>}
    </S.Root>
  );
}

export default Filter;